export type CompanyData = {
  // company: {
  [key: string]: string
  // }
  // document: File | null
  // agreements: { [key: string]: any }
}

export type DataOrganizations = {
  name: string,
  inn: string,
  kpp: string,
  ogrn: string,
  index: string,
  address: string,
  phone: string,
  email: string,
  okved: string
}

export enum CompanyRegistrationStep {
  Greeting,
  CompanyDataTin,
  // PowerOfAttorney,
  // CompanyDataFilling,
  EmailValidation,
  CodeEmail,
  FinishRegistration,
}

export type DataAgreeInfo = {
  oferta: boolean,
  agree: boolean
}
